export default __webpack_public_path__ + "static/media/Arrow-straight-money.0f2001e1.svg";